import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const WhyChooseUs = () => {
  const [activeTab, setActiveTab] = useState("mission");

  const tabs = [
    { id: "mission", label: "Our Mission" },
    { id: "vision", label: "Our Vision" },
    { id: "value", label: "Our Values" },
  ];

  const content = {
    mission: {
      title: "Building the Future of Real Estate in Nigeria",
      text: "To enrich lives through innovative real estate solutions, exceptional service, and sustainable growth — becoming Nigeria’s most trusted property partner.",
      img: "assets/img/main/h4.jpg",
    },
    vision: {
      title: "Redefining Nigerian Real Estate Standards",
      text: "To be Nigeria’s foremost developer of innovative, well‑designed, sustainable residential and commercial properties.",
      img: "assets/img/main/h3.jpg",
    },
    value: {
      title: "Quality, Integrity & Reliability",
      text: "We walk our talk through Collaboration, Character, Capacity, Credibility, and Integrity.",
      img: "assets/img/main/mission_3_3.jpg",
    },
  };

  return (
    <div className="pb-4">
      <style>{`
        .why-choose-us {
          padding-top: 2rem;
        }
        .tab-menu2 {
          display: flex;
          justify-content: center;
          gap: 20px;
          margin-bottom: 2.5rem;
        }
        .tab-menu2 button {
          background: transparent;
          border: none;
          padding: 10px 28px;
          font-size: 1rem;
          font-weight: 600;
          color: #555;
          border-radius: 50px;
          transition: all 0.3s ease;
          cursor: pointer;
          border: 1px solid transparent;
        }
        .tab-menu2 button.active {
          background: #e86b24;
          color: #fff;
          border-color: #e86b24;
        }
        .tab-menu2 button:hover:not(.active) {
          border-color: #e86b24;
          color: #e86b24;
        }
        .mission-grid {
          display: flex;
          align-items: center;
          gap: 40px;
          flex-wrap: wrap;
        }
        .mission-img {
          flex: 1 1 300px;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        .mission-img img {
          width: 100%;
          height: 350px;
          object-fit: cover;
          display: block;
        }
        .mission-content {
          flex: 1 1 300px;
        }
        .mission-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1rem;
        }
        .mission-text {
          font-size: 1rem;
          color: #555;
          line-height: 1.7;
          margin-bottom: 1.5rem;
        }
        .checklist.style5 {
          list-style: none;
          padding: 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 2rem;
        }
        .checklist.style5 li {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.95rem;
          color: #333;
        }
        .checklist.style5 li:before {
          content: "✓";
          color: #e86b24;
          font-weight: bold;
        }
        .mission-feature-wrap {
          display: flex;
          gap: 30px;
        }
        .mission-feature {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .mission-feature_icon img {
          width: 40px;
          height: 40px;
        }
        .mission-feature_subtitle {
          font-size: 0.8rem;
          color: #888;
          margin-bottom: 0.2rem;
        }
        .mission-feature_title {
          font-size: 1rem;
          font-weight: 600;
          color: #0a1a3d;
        }
        @media (max-width: 768px) {
          .mission-grid {
            flex-direction: column;
          }
          .mission-img {
            width: 100%;
          }
        }
      `}</style>

      <div className="container why-choose-us">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <div className="title-area text-center">
              <span className="sub-title6 d-flex justify-content-center align-items-center">
                <span className="shape left"><span className="dots"></span></span>
                Our Core Pillars
                <span className="shape right"><span className="dots"></span></span>
              </span>
              <h2 className="sec-title">Why We’re The Trusted Choice</h2>
            </div>
          </div>
        </div>

        <div className="tab-menu2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={activeTab === tab.id ? "active" : ""}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="mission-grid"
          >
            <div className="mission-img">
              <img src={content[activeTab].img} alt={activeTab} />
            </div>
            <div className="mission-content">
              <h3 className="mission-title">{content[activeTab].title}</h3>
              <p className="mission-text">{content[activeTab].text}</p>
              <div className="checklist style5">
                <ul>
                  <li>Residential Estates</li>
                  <li>Commercial Properties</li>
                  <li>Heavy Engineering</li>
                  <li>Institutional Buildings</li>
                </ul>
              </div>
              <div className="mission-feature-wrap">
                <div className="mission-feature">
                  <div className="mission-feature_icon">
                    <img src="assets/img/update1/icon/mission_1_1.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <p className="mission-feature_subtitle">Expertise</p>
                    <h4 className="mission-feature_title">Construction Services</h4>
                  </div>
                </div>
                <div className="mission-feature">
                  <div className="mission-feature_icon">
                    <img src="assets/img/update1/icon/mission_1_2.svg" alt="icon" />
                  </div>
                  <div className="media-body">
                    <p className="mission-feature_subtitle">Design</p>
                    <h4 className="mission-feature_title">Architecture & Planning</h4>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default WhyChooseUs;